import * as React from 'react';

import { CheckCircleOutlined as CheckIcon } from '@ant-design/icons';

import clsx from 'clsx';
import { useFormikContext } from 'formik';

import { useStepper } from '../context';

const STEP_ITEM_HEIGHT = 32;
const steps = ['Dados bancários', 'Documentos', 'Comprovante', 'Resumo', 'Verificação'];

function Wizard() {
  const { currentStep, goToStep } = useStepper();
  const formik = useFormikContext();

  function handleDoneClick(stepPosition: number) {
    goToStep(stepPosition);
  }

  const hasStepsFinished = currentStep > steps.length;
  const offsetMultiplier = (hasStepsFinished ? steps.length : currentStep) - 1;
  const positionIndicatorTopOffset = STEP_ITEM_HEIGHT * offsetMultiplier;

  return (
    <aside className='absolute -left-1/2 h-full max-[1500px]:left-[-30%] max-[1100px]:hidden [&_nav]:fixed [&_nav]:-translate-x-1/2 [&_nav>span]:absolute [&_nav>span]:left-0 [&_nav>span]:h-8 [&_nav>span]:w-0.5 [&_nav>span]:bg-[#072D83] [&_nav>span]:transition-[top,opacity] [&_nav>span]:duration-500 [&_ol]:flex [&_ol]:list-none [&_ol]:flex-col [&_ol]:border-l [&_ol]:border-[#B0BEC5]'>
      <nav>
        <span
          className={hasStepsFinished ? 'opacity-0' : ''}
          role='presentation'
          aria-valuenow={currentStep}
          style={{ top: positionIndicatorTopOffset }}
        />
        <ol>
          {steps.map((step, index) => {
            const position = index + 1;
            const isDone = currentStep > position;
            const isCurrent = currentStep === position;
            const isNext = currentStep < position;
            return (
              <li
                key={step}
                className={clsx(
                  isDone && '[&_button]:text-grey-500 [&_button]:cursor-pointer',
                  isCurrent && '[&_button]:font-bold [&_button]:text-[#072D83]',
                  isNext && '[&_button]:cursor-not-allowed [&_button]:text-[#B0BEC5]'
                )}
                {...(isDone && { onClick: () => handleDoneClick(position) })}
              >
                <button
                  className='flex h-8 items-center border-0 bg-transparent pl-4 font-sans text-sm leading-8 font-semibold disabled:cursor-not-allowed'
                  id={`step-nav-btn-${position}`}
                  disabled={formik?.isSubmitting}
                >
                  <CheckIcon
                    className={clsx(
                      'text-success mr-[5px] w-0 scale-0 text-base transition-[transform,width] duration-500',
                      isDone && 'w-4 scale-100'
                    )}
                  />
                  {step}
                </button>
              </li>
            );
          })}
        </ol>
      </nav>
    </aside>
  );
}

export { Wizard };
